var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our-clients-page"},[_c('testimonial',{attrs:{"testimonial-name":"Ognen Trajkovski","testimonial-company":"Vitech  DevelopmentDevelopmentDevelopmentDevelopment"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }